const enum ISignupFormStatus {
  Default = 'DEFAULT',
  Loading = 'LOADING',
  Verified = 'VERIFIED',
  Submitted = 'SUBMITTED',
  Errored = 'ERRORED',
}

export default ISignupFormStatus;
